<template>
	<transition name="modal">
		<div>
			<div class="modal-mask" :style="{zIndex: layerIndex}">
				<div class="modal-wrapper has-scroll" :class="`modal-wrapper-${wrapper}`">
					<div class="modal-container" :class="`modal-container-${size}`">
						<div class="modal-header capitalize text-xlg pl-4" v-if="$slots.header">
							<slot name="header">
								Modal Header
							</slot>
							<div class="modal-close" @click="$emit('close')" v-if="!hideCloseButton">
								<i class="material-icons">close</i>
							</div>
							<button type="button" class="close hidden" aria-label="Close" @click="$emit('close')">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>

						<div class="modal-body" :class="{ 'p-0': full }">
							<slot name="body">
								Modal Body
							</slot>
						</div>

						<div class="modal-footer" v-if="!hideFooter">
							<slot name="footer">
								<button class="btn btn-primary" @click="$emit('close')">OK</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Modal',
	props: {
		size: {
			type: String,
			default: 'small',
		},
		wrapper: {
			type: String,
			default: 'small',
		},
		hideFooter: {
			type: Boolean,
			default: false,
		},
		full: {
			type: Boolean,
			default: false,
		},
		hideCloseButton: {
		},
		layerIndex: {
			default: 9998,
		},
	},
	methods: {
		onKeyup(event) {
			if (event.key === 'Escape') {
				this.$emit('close');
			}
		},
	},
	created() {
		document.body.classList.add('modal-open');
		window.addEventListener('keyup', this.onKeyup);
	},
	destroyed() {
		document.body.classList.remove('modal-open');
		window.removeEventListener('keyup', this.onKeyup);
	},
};
</script>

<style lang="scss">
</style>
